import * as React from 'react';
import { FormControlLabel, TextField, Typography, WithStyles, Theme, createStyles, withStyles, Grid } from '@material-ui/core';
import { Utilities } from '../general/utilities';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PublishIcon from '@material-ui/icons/Publish';
import {  InputFilenameAId, InputFilenameBId } from './ConfigFormData';
import { DeltaXMLColors, MyDeltaColors } from '../material-ui/styling/DeltaColors';
import { MuiStyles } from './styling/MuiStyles';

export enum InputIdentifier {
    A,
    B
}

const styles = (theme: Theme) =>
    createStyles({
        fileLabel: {
            marginStart: '1em',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '300px',
            overflow: 'hidden'
        },
        fileSize: {
            marginStart: '2em'
        },
        formLabelButton: {
            display: 'inline-flex',
            marginEnd: '4px',
            backgroundColor: 'transparent',
            border: '1px solid',
            color: DeltaXMLColors.OXFORD_BLUE,
            padding: '5px 5px',
            marginStart: '0px',
            '&:hover': {
                // Set hover color
                backgroundColor: DeltaXMLColors.OXFORD_BLUE,
                color: MyDeltaColors.WHITE,
                border: '1px solid ' + DeltaXMLColors.OXFORD_BLUE,
                boxShadow: 'none'
            },
            width: '131px',
            flexDirection: 'column'
        },
        formLabelLabel: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'transparent',
        },
        errorIcon: {
            color: DeltaXMLColors.VALENTINE_RED
        },
        inputIcon: {
            fontSize: '20px',
            color: DeltaXMLColors.FOUNTAIN_BLUE,
            marginLeft: '6px',
            marginRight: '-4px',
            height: '1em',
            width: '1em'
        },
        errorGridItem: {
            paddingTop: '9px'
        },
        checkIcon: {
            color: DeltaXMLColors.CELERY
        }
    });

export interface FileInputProps extends WithStyles<typeof styles> {
    onFormChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputFilename: string,
    inputFile: File | null,
    inputIdentifier: InputIdentifier,
    errorMessage: string | null
}

function FileInput(props: FileInputProps) {
    const { classes, onFormChange, inputFilename, inputFile, inputIdentifier, errorMessage } = props;
    let inputName: string = "", inputLabel: string = "";
    switch (inputIdentifier) {
        case InputIdentifier.A:
            inputName = InputFilenameAId;
            inputLabel = "Input File A";
            break;
        case InputIdentifier.B:
            inputName = InputFilenameBId;
            inputLabel = "Input File B";
            break;
    }

    const errorHeading = errorMessage;
    let fileIcon : JSX.Element;
    if (errorMessage === Utilities.fileUploadSuccessful) {
        fileIcon = <CheckCircleIcon className={classes.checkIcon} />
    } else {
        fileIcon = <ErrorIcon className={classes.errorIcon} />
    }


    
    return (
        <Grid container >
            <Grid item xs={11}>
                <FormControlLabel
                    className={classes.formLabelButton}
                    control={<div className={classes.formLabelLabel}>
                        {inputLabel}
                        <input type="file" style={{ display: 'none' }} name={inputName} onChange={onFormChange} />
                        <PublishIcon className={classes.inputIcon} />
                    </div>
                    }
                    label={''}
                    labelPlacement="start"
                />
                <TextField fullWidth className={classes.fileLabel} id={inputName} value={inputFilename} spellCheck={false} />
                <Typography variant="body2" color="secondary" gutterBottom className={classes.fileSize}>{Utilities.getReadableFileSizeString(inputFile)}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.errorGridItem}>
                {errorMessage &&
                    <MuiStyles.HtmlTooltip
                        arrow
                        title={
                            <React.Fragment>
                                <Typography color="inherit" variant="body2">{errorHeading}</Typography>
                              
                            </React.Fragment>
                        }
                    >
                          {fileIcon} 
                    </MuiStyles.HtmlTooltip>
                } 
            </Grid>
        </Grid >
    )

}

export default withStyles(styles)(FileInput);